import { render, staticRenderFns } from "./TarifVertragSelector.vue?vue&type=template&id=25f14b95&"
import script from "./TarifVertragSelector.vue?vue&type=script&lang=js&"
export * from "./TarifVertragSelector.vue?vue&type=script&lang=js&"
import style0 from "./TarifVertragSelector.vue?vue&type=style&index=0&id=25f14b95&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports